const settings = {
    label: "Social Media",
    name: "socialmedia",
    file: "site/data/socialmedia.yaml",
    i18n: true,
    fields: [
        {
            label: "Twitter Feed",
            name: "twitter",
            widget: "object",
            i18n: true,
            fields: [
                {
                    label: "Off/On",
                    name: "active",
                    widget: "boolean",
                    required: false,
                    default: false,
                    i18n: true,
                },
                {
                    label: "Feed Url",
                    name: "url",
                    widget: "string",
                    required: false,
                    i18n: true
                },
                {
                    label: "Feed Id",
                    name: "id",
                    widget: "string",
                    required: false,
                    i18n: true
                },
                {
                    label: "Max Tweets",
                    name: "num",
                    widget: "number",
                    required: false,
                    i18n: true
                }
            ]
        },
        {
            label: "Social Links",
            name: "links",
            widget: "list",
            i18n: true,
            fields: [

                {
                    label: "Type",
                    name: "type",
                    widget: "string",
                    i18n: true
                },
                {
                    label: "id",
                    name: "id",
                    widget: "string",
                    i18n: true
                },
                {
                    label: "url",
                    name: "url",
                    widget: "string",
                    i18n: true
                },
                {
                    label: "Hide",
                    name: "hide",
                    widget: "boolean",
                    i18n: true,
                    required: false,
                    default: false
                },
            ]
        },
        {
            label: "Share platforms",
            name: "shares",
            widget: "object",
            i18n: true,
            fields: [
                {
                    label: "enable",
                    name: "enable",
                    widget: "boolean",
                    i18n: true,
                    required: false,
                    default: false
                },
                {
                    label: "Twitter",
                    name: "Twitter",
                    widget: "boolean",
                    i18n: true,
                    required: false,
                    default: false
                },
                {
                    label: "Facebook",
                    name: "Facebook",
                    widget: "boolean",
                    i18n: true,
                    required: false,
                    default: false
                },
                {
                    label: "Linkedin",
                    name: "Linkedin",
                    widget: "boolean",
                    i18n: true,
                    required: false,
                    default: false
                },
                {
                    label: "Whatsapp",
                    name: "Whatsapp",
                    widget: "boolean",
                    i18n: true,
                    required: false,
                    default: false
                },
                {
                    label: "Pinterest",
                    name: "Pinterest",
                    widget: "boolean",
                    i18n: true,
                    required: false,
                    default: false
                },
                {
                    label: "Tumblr",
                    name: "Tumblr",
                    widget: "boolean",
                    i18n: true,
                    required: false,
                    default: false
                },
                {
                    label: "HackerNews",
                    name: "HackerNews",
                    widget: "boolean",
                    i18n: true,
                    required: false,
                    default: false
                },
                {
                    label: "Reddit",
                    name: "Reddit",
                    widget: "boolean",
                    i18n: true,
                    required: false,
                    default: false
                },
                {
                    label: "VK",
                    name: "VK",
                    widget: "boolean",
                    i18n: true,
                    required: false,
                    default: false
                },
                {
                    label: "Buffer",
                    name: "Buffer",
                    widget: "boolean",
                    i18n: true,
                    required: false,
                    default: false
                },
                {
                    label: "Xing",
                    name: "Xing",
                    widget: "boolean",
                    i18n: true,
                    required: false,
                    default: false
                },
                {
                    label: "Line",
                    name: "Line",
                    widget: "boolean",
                    i18n: true,
                    required: false,
                    default: false
                },
                {
                    label: "Instapaper",
                    name: "Instapaper",
                    widget: "boolean",
                    i18n: true,
                    required: false,
                    default: false
                },
                {
                    label: "Pocket",
                    name: "Pocket",
                    widget: "boolean",
                    i18n: true,
                    required: false,
                    default: false
                },
                {
                    label: "Digg",
                    name: "Digg",
                    widget: "boolean",
                    i18n: true,
                    required: false,
                    default: false
                },
                {
                    label: "Stumbleupon",
                    name: "Stumbleupon",
                    widget: "boolean",
                    i18n: true,
                    required: false,
                    default: false
                },
                {
                    label: "Flipboard",
                    name: "Flipboard",
                    widget: "boolean",
                    i18n: true,
                    required: false,
                    default: false
                },
                {
                    label: "Weibo",
                    name: "Weibo",
                    widget: "boolean",
                    i18n: true,
                    required: false,
                    default: false
                },
                {
                    label: "Renren",
                    name: "Renren",
                    widget: "boolean",
                    i18n: true,
                    required: false,
                    default: false
                },
                {
                    label: "Myspace",
                    name: "Myspace",
                    widget: "boolean",
                    i18n: true,
                    required: false,
                    default: false
                },
                {
                    label: "Blogger",
                    name: "Blogger",
                    widget: "boolean",
                    i18n: true,
                    required: false,
                    default: false
                },
                {
                    label: "Baidu",
                    name: "Baidu",
                    widget: "boolean",
                    i18n: true,
                    required: false,
                    default: false
                },
                {
                    label: "Odnoklassniki",
                    name: "Odnoklassniki",
                    widget: "boolean",
                    i18n: true,
                    required: false,
                    default: false
                },
                {
                    label: "Evernote",
                    name: "Evernote",
                    widget: "boolean",
                    i18n: true,
                    required: false,
                    default: false
                },
                {
                    label: "Skype",
                    name: "Skype",
                    widget: "boolean",
                    i18n: true,
                    required: false,
                    default: false
                },
                {
                    label: "Trello",
                    name: "Trello",
                    widget: "boolean",
                    i18n: true,
                    required: false,
                    default: false
                },
                {
                    label: "Mix",
                    name: "Mix",
                    widget: "boolean",
                    i18n: true,
                    required: false,
                    default: false
                },
                {
                    label: "Telegram",
                    name: "Telegram",
                    required: false,
                    widget: "boolean",
                    i18n: true,
                    default: false
                }
            ]
        }
    ]
}

export default settings;
